import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

import { defaultValues } from './model';
import { revenueLockdownFormSchema, type RevenueLockdownFormSchema } from './revenue-lockdown-form-schema';

export function useFormDefinition() {
  return useForm<RevenueLockdownFormSchema>({
    resolver: zodResolver(revenueLockdownFormSchema),
    defaultValues,
    shouldFocusError: true,
  });
}
